/*global angular */

(function (angular) {
'use strict';

var misc = angular.module('misc', [
    'misc.directives'
]);
}(angular));
